export enum ApprovalStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export enum EmployeeStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  ARCHIVED = "ARCHIVED",
}

export enum ProjectStatus {
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  ON_HOLD = "ON_HOLD",
  CANCELLED = "CANCELLED",
}

export enum UserRole {
  SUPERADMIN = "SUPERADMIN",
  MANAGER = "MANAGER",
  SUPERVISOR = "SUPERVISOR",
}

export enum AppSettingsItems {
  DEPARTMENT_LIST = "department_list",
}

export enum ProjectRevisionType {
  PROJECT_CREATED = "PROJECT_CREATED",
  PROJECT_UPDATED = "PROJECT_UPDATED",
  PROJECT_STATUS_CHANGED = "PROJECT_STATUS_CHANGED",
  OVERTIME_ADDED = "OVERTIME_ADDED",
  OVERTIME_UPDATED = "OVERTIME_UPDATED",
  OVERTIME_STATUS_CHANGED = "OVERTIME_STATUS_CHANGED",
  OVERTIME_PAYMENT_STATUS_CHANGED = "OVERTIME_PAYMENT_STATUS_CHANGED",
}

export const DEFAULT_DEPARTMENTS = [
  "Project Supervisor",
  "Project Manager",
] as const;
